import { render, staticRenderFns } from "./custom-link-type-1.vue?vue&type=template&id=6cb022f5&scoped=true&"
import script from "./custom-link-type-1.vue?vue&type=script&lang=js&"
export * from "./custom-link-type-1.vue?vue&type=script&lang=js&"
import style0 from "./custom-link-type-1.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./custom-link-type-1.vue?vue&type=style&index=1&id=6cb022f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb022f5",
  null
  
)

export default component.exports